/** localStorage key for display app JWT (separate from main app). */
export const DISPLAY_TOKEN_KEY = 'mywellfie_display_token';
